import { Check, X } from "lucide-react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import {
  getSignalBubbleClassName,
  type RequestSignalBubble,
} from "@/routes/request-logs/search/signal-search-utils";

interface SignalBubbleProps {
  signal: RequestSignalBubble;
}

const SignalBubble = ({ signal }: SignalBubbleProps) => {
  const ValueIcon = signal.isTrue ? Check : X;
  const bubble = (
    <span
      className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-xs font-medium ${getSignalBubbleClassName()}`}
    >
      <ValueIcon className="h-3 w-3 shrink-0" aria-hidden="true" />
      {signal.name}
    </span>
  );

  if (!signal.justification) {
    return bubble;
  }

  return (
    <BasicTooltip content={signal.justification}>
      <span className="inline-flex cursor-default">{bubble}</span>
    </BasicTooltip>
  );
};

export default SignalBubble;
